import React, { useState, useRef } from "react";
import { 
  FaPhoneAlt, 
  FaEnvelope, 
  FaMapMarkerAlt, 
  FaLinkedin, 
  FaGithub,
  FaReact,
  FaNodeJs,
  FaJs,
  FaHtml5,
  FaCss3,
  FaGitAlt,
  FaCode,
  FaShieldAlt,
  FaCertificate,
  FaRocket,
  FaStar,
  FaBolt,
  FaHandshake,
  FaArrowRight,
  FaDownload,
  FaFilePdf,
  FaPrint,
  FaSpinner
} from "react-icons/fa";
import { SiTailwindcss, SiTypescript, SiNextdotjs } from "react-icons/si";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const CV = () => {
  const [showHirePopup, setShowHirePopup] = useState(false);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const cvContentRef = useRef(null);

  const bg = "#f8fafc";
  const cardBg = "#ffffff";
  const text = "#0f172a";
  const subText = "#475569";
  const accent = "#FF4444";

  // Hire Now ক্লিক হ্যান্ডলার
  const handleHireClick = () => {
    setShowHirePopup(true);
    setTimeout(() => setShowHirePopup(false), 4000);
  };

  // PDF ডাউনলোড হ্যান্ডলার
  const handleDownloadPDF = async () => {
    if (!cvContentRef.current) return;
    
    setIsGeneratingPDF(true);
    
    try {
      const element = cvContentRef.current;
      
      const canvas = await html2canvas(element, {
        scale: 3,
        backgroundColor: "#ffffff",
        logging: false,
        useCORS: true,
      });
      
      const imgData = canvas.toDataURL('image/png');
      
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4',
      });
      
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = pdfWidth;
      const imgHeight = (canvas.height * pdfWidth) / canvas.width;
      
      let heightLeft = imgHeight;
      let position = 0;
      
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pdfHeight;
      
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pdfHeight;
      }
      
      pdf.save('MD_Shafiul_Alam_CV.pdf');
    } catch (error) {
      console.error('PDF generation failed:', error);
      alert('Failed to generate PDF. Please try again.');
    } finally {
      setIsGeneratingPDF(false);
    }
  };

  // প্রিন্ট হ্যান্ডলার
  const handlePrint = () => {
    window.print();
  };

  const companyInfo = {
    name: "YourAgency",
    fullName: "YourAgency Digital Solutions",
    established: "2020",
    website: "www.youragency.com",
    regNo: "REG-2024-0X7F9",
    location: "Dhaka, Bangladesh",
    hireInfo: {
      available: "Immediately",
      rate: "Negotiable",
      projects: "15+ Completed",
      satisfaction: "98%"
    }
  };

  const skills = [
    { name: "React", icon: FaReact, color: "#61DAFB" },
    { name: "JavaScript", icon: FaJs, color: "#F7DF1E" },
    { name: "Node.js", icon: FaNodeJs, color: "#339933" },
    { name: "HTML5", icon: FaHtml5, color: "#E34F26" },
    { name: "CSS3", icon: FaCss3, color: "#1572B6" },
    { name: "Tailwind", icon: SiTailwindcss, color: "#06B6D4" },
    { name: "TypeScript", icon: SiTypescript, color: "#3178C6" },
    { name: "Next.js", icon: SiNextdotjs, color: "#000" },
    { name: "Git", icon: FaGitAlt, color: "#F05032" },
  ];

  const experiences = [
    {
      title: "Lead of Operations & Developer",
      company: "YourAgency",
      period: "2020 - Present",
      description: "Leading development teams and managing full-stack web applications. Implemented agile methodologies and improved team productivity by 40%.",
      achievements: [
        "Architected and deployed 15+ enterprise-level applications",
        "Mentored junior developers and conducted code reviews",
        "Reduced application load time by 60% through optimization"
      ]
    },
    {
      title: "Frontend Developer",
      company: "TechStartup",
      period: "2018 - 2020",
      description: "Developed responsive user interfaces and collaborated with design teams to enhance user experience.",
      achievements: [
        "Built reusable component library used across 5 projects",
        "Implemented responsive designs for mobile and desktop",
        "Achieved 95%+ Lighthouse performance scores"
      ]
    }
  ];

  const education = {
    degree: "B.Sc. in Computer Science",
    institution: "Dhaka University",
    period: "2014 - 2018",
    cgpa: "3.8/4.0",
    courses: ["Data Structures", "Algorithms", "Web Development", "Database Management"]
  };

  return (
    <>
      {/* Main CV Display */}
      <div ref={cvContentRef} style={{
        minHeight: "100vh",
        background: bg,
        color: text,
        padding: "100px 24px 100px",
        position: "relative",
        zIndex: 1,
        transition: "all 0.3s ease",
      }}>
        
        {/* HIRE NOW পপআপ */}
        {showHirePopup && (
          <div style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 9999,
            animation: "popupSlide 0.5s ease",
          }}>
            <style>
              {`
                @keyframes popupSlide {
                  0% { transform: translate(-50%, -30%); opacity: 0; }
                  100% { transform: translate(-50%, -50%); opacity: 1; }
                }
                @keyframes rocket {
                  0% { transform: translateY(0) rotate(0deg); }
                  50% { transform: translateY(-10px) rotate(5deg); }
                  100% { transform: translateY(0) rotate(0deg); }
                }
              `}
            </style>
            <div style={{
              background: "linear-gradient(135deg, #FF4444, #FF6B6B, #FF8A8A)",
              padding: "30px 40px",
              borderRadius: "20px",
              boxShadow: "0 20px 40px rgba(255,68,68,0.4)",
              textAlign: "center",
              border: "2px solid rgba(255,255,255,0.2)",
              backdropFilter: "blur(10px)",
              position: "relative",
              overflow: "hidden",
            }}>
              <FaRocket style={{
                fontSize: "50px",
                color: "#fff",
                marginBottom: "15px",
                animation: "rocket 2s ease-in-out infinite",
              }} />
              
              <h3 style={{
                color: "#fff",
                fontSize: "28px",
                marginBottom: "10px",
                textShadow: "0 2px 10px rgba(0,0,0,0.2)",
              }}>
                Thank You!
              </h3>
              
              <p style={{
                color: "#fff",
                fontSize: "16px",
                marginBottom: "20px",
                opacity: 0.9,
              }}>
                Your hiring request has been sent successfully!
              </p>
              
              <div style={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
              }}>
                {[1,2,3,4,5].map((_, i) => (
                  <FaStar key={i} style={{ color: "#FFD700", fontSize: "20px" }} />
                ))}
              </div>
              
              <p style={{
                color: "#fff",
                fontSize: "14px",
                marginTop: "15px",
                opacity: 0.8,
              }}>
                We'll contact you within 24 hours
              </p>
            </div>
          </div>
        )}

        {/* ওয়াটারমার্ক ব্যাকগ্রাউন্ড */}
        <div style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%) rotate(-30deg)",
          fontSize: "120px",
          fontWeight: "bold",
          color: "rgba(255,68,68,0.02)",
          whiteSpace: "nowrap",
          pointerEvents: "none",
          zIndex: 0,
          fontFamily: "Arial, sans-serif",
          letterSpacing: "20px",
        }}>
          YOURAGENCY
        </div>

        {/* হেডার সেকশন */}
        <div style={{ maxWidth: "1000px", margin: "0 auto", position: "relative", zIndex: 1 }}>
          {/* HIRE NOW বিজ্ঞাপন ব্যানার */}
          <div style={{
            background: "linear-gradient(135deg, #FF4444, #FF6B6B, #FF8A8A)",
            borderRadius: "15px",
            padding: "15px 20px",
            marginBottom: "30px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: "15px",
            boxShadow: "0 10px 25px rgba(255,68,68,0.3)",
            position: "relative",
            overflow: "hidden",
            border: "1px solid rgba(255,255,255,0.2)",
          }}>
            <div style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent)",
              animation: "shimmer 2s infinite",
            }} />
            
            <style>
              {`
                @keyframes shimmer {
                  0% { transform: translateX(-100%); }
                  100% { transform: translateX(100%); }
                }
              `}
            </style>

            <div style={{ display: "flex", alignItems: "center", gap: "20px", flexWrap: "wrap" }}>
              <div style={{
                background: "rgba(255,255,255,0.2)",
                padding: "10px 15px",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}>
                <FaBolt style={{ color: "#fff", fontSize: "20px" }} />
                <span style={{ color: "#fff", fontWeight: "bold" }}>Available {companyInfo.hireInfo.available}</span>
              </div>
              
              <div style={{
                background: "rgba(255,255,255,0.2)",
                padding: "10px 15px",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}>
                <FaStar style={{ color: "#FFD700", fontSize: "20px" }} />
                <span style={{ color: "#fff", fontWeight: "bold" }}>{companyInfo.hireInfo.satisfaction} Client Satisfaction</span>
              </div>
              
              <div style={{
                background: "rgba(255,255,255,0.2)",
                padding: "10px 15px",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}>
                <FaHandshake style={{ color: "#fff", fontSize: "20px" }} />
                <span style={{ color: "#fff", fontWeight: "bold" }}>{companyInfo.hireInfo.projects} Projects Done</span>
              </div>
            </div>

            <button
              onClick={handleHireClick}
              style={{
                padding: "15px 40px",
                borderRadius: "50px",
                border: "none",
                background: "#fff",
                color: accent,
                fontWeight: "bold",
                fontSize: "20px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                boxShadow: "0 5px 20px rgba(0,0,0,0.2)",
                transition: "all 0.3s ease",
                position: "relative",
                overflow: "hidden",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.05)";
                e.currentTarget.style.boxShadow = "0 8px 25px rgba(0,0,0,0.3)";
                e.currentTarget.style.background = "#FF4444";
                e.currentTarget.style.color = "#fff";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "0 5px 20px rgba(0,0,0,0.2)";
                e.currentTarget.style.background = "#fff";
                e.currentTarget.style.color = accent;
              }}
            >
              <FaRocket style={{ fontSize: "24px" }} />
              HIRE ME NOW
              <FaArrowRight style={{ fontSize: "20px" }} />
            </button>
          </div>

          {/* সীল সহ হেডার */}
          <div style={{ 
            display: "flex", 
            alignItems: "center", 
            justifyContent: "space-between",
            marginBottom: "40px",
            background: cardBg,
            padding: "20px 30px",
            borderRadius: "20px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
            border: "1px solid rgba(0,0,0,0.05)",
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <div style={{
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                background: `linear-gradient(135deg, ${accent}, #FF8888)`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "32px",
                fontWeight: "bold",
                color: "#fff",
                boxShadow: "0 10px 25px rgba(255,68,68,0.3)",
              }}>
                SA
              </div>
              <div>
                <h1 style={{ fontSize: "28px", marginBottom: "5px", color: text }}>
                  MD SHAFIUL ALAM
                </h1>
                <p style={{ fontSize: "14px", color: subText }}>
                  Lead of Operations & Developer
                </p>
              </div>
            </div>

            <div style={{
              position: "relative",
              width: "120px",
              height: "120px",
            }}>
              <style>
                {`
                  @keyframes glow {
                    0%, 100% { filter: drop-shadow(0 0 5px rgba(255,68,68,0.3)); }
                    50% { filter: drop-shadow(0 0 15px rgba(255,68,68,0.6)); }
                  }
                `}
              </style>

              <svg width="120" height="120" viewBox="0 0 120 120" style={{ position: "absolute", animation: "glow 3s ease-in-out infinite" }}>
                <defs>
                  <linearGradient id="sealGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#FF4444" stopOpacity="0.8" />
                    <stop offset="50%" stopColor="#FF8A8A" stopOpacity="0.6" />
                    <stop offset="100%" stopColor="#FF4444" stopOpacity="0.8" />
                  </linearGradient>
                  <linearGradient id="hologramGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#FFD700" stopOpacity="0.3" />
                    <stop offset="50%" stopColor="#FFED4E" stopOpacity="0.2" />
                    <stop offset="100%" stopColor="#FFD700" stopOpacity="0.3" />
                  </linearGradient>
                </defs>
                <circle cx="60" cy="60" r="50" fill="url(#sealGradient)" opacity="0.1" />
                <circle cx="60" cy="60" r="45" fill="none" stroke="url(#sealGradient)" strokeWidth="2" strokeDasharray="6 6" />
                <circle cx="60" cy="60" r="40" fill="url(#hologramGradient)" opacity="0.2" />
                <path id="circlePath" d="M 60,60 m -35,0 a 35,35 0 1,1 70,0 a 35,35 0 1,1 -70,0" fill="none" />
                <text style={{ fontSize: "8px", letterSpacing: "2px" }}>
                  <textPath href="#circlePath" fill={accent} startOffset="25%">
                    • YOURAGENCY • OFFICIAL
                  </textPath>
                </text>
                <circle cx="60" cy="60" r="25" fill="none" stroke="url(#sealGradient)" strokeWidth="1.5" />
                <circle cx="60" cy="60" r="20" fill="none" stroke="url(#sealGradient)" strokeWidth="1" strokeDasharray="3 3" />
                <circle cx="60" cy="60" r="12" fill={`${accent}20`} />
                <circle cx="60" cy="60" r="8" fill={accent} opacity="0.3" />
                <circle cx="60" cy="60" r="4" fill={accent} />
                
                {[0, 45, 90, 135, 180, 225, 270, 315].map((angle, i) => {
                  const rad = (angle * Math.PI) / 180;
                  const x1 = 60 + 40 * Math.cos(rad);
                  const y1 = 60 + 40 * Math.sin(rad);
                  const x2 = 60 + 45 * Math.cos(rad);
                  const y2 = 60 + 45 * Math.sin(rad);
                  return (
                    <line
                      key={i}
                      x1={x1}
                      y1={y1}
                      x2={x2}
                      y2={y2}
                      stroke={accent}
                      strokeWidth="1.5"
                      opacity="0.6"
                    />
                  );
                })}
              </svg>

              <div style={{
                position: "absolute",
                bottom: "-25px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "140px",
                textAlign: "center",
                fontSize: "8px",
                color: accent,
                fontWeight: "bold",
                background: cardBg,
                padding: "4px 8px",
                borderRadius: "10px",
                border: `1px solid ${accent}40`,
                boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
                letterSpacing: "1px",
              }}>
                {companyInfo.regNo}
              </div>

              <div style={{
                position: "absolute",
                top: "-10px",
                right: "-10px",
                background: "linear-gradient(135deg, #4CAF50, #45a049)",
                borderRadius: "20px",
                padding: "4px 10px",
                display: "flex",
                alignItems: "center",
                gap: "5px",
                fontSize: "8px",
                fontWeight: "bold",
                color: "#fff",
                boxShadow: "0 2px 8px rgba(76,175,80,0.4)",
              }}>
                <FaShieldAlt size={10} />
                <span>VERIFIED</span>
              </div>
            </div>
          </div>

          {/* কোম্পানি ইনফো বার */}
          <div style={{
            background: cardBg,
            padding: "15px 20px",
            borderRadius: "12px",
            marginBottom: "30px",
            boxShadow: "0 5px 15px rgba(0,0,0,0.05)",
            border: "1px solid rgba(0,0,0,0.05)",
            display: "flex",
            justifyContent: "space-around",
            flexWrap: "wrap",
            gap: "15px",
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <FaCertificate color={accent} size={14} />
              <span style={{ fontSize: "12px", color: subText }}>{companyInfo.fullName}</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <FaShieldAlt color={accent} size={14} />
              <span style={{ fontSize: "12px", color: subText }}>Est. {companyInfo.established}</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <FaMapMarkerAlt color={accent} size={14} />
              <span style={{ fontSize: "12px", color: subText }}>{companyInfo.location}</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <FaCode color={accent} size={14} />
              <span style={{ fontSize: "12px", color: subText }}>{companyInfo.website}</span>
            </div>
          </div>

          {/* কন্টাক্ট গ্রিড */}
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            gap: "15px",
            marginBottom: "30px",
          }}>
            {[
              { icon: FaPhoneAlt, label: "+880 1234 567 890" },
              { icon: FaEnvelope, label: "shafiul.alam@youragency.com" },
              { icon: FaLinkedin, label: "linkedin.com/in/shafiulalam", color: "#0A66C2" },
              { icon: FaGithub, label: "github.com/shafiulalam", color: "#333" },
            ].map((item, idx) => (
              <div key={idx} style={{
                background: cardBg,
                padding: "12px",
                borderRadius: "10px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                border: "1px solid rgba(0,0,0,0.05)",
              }}>
                <item.icon style={{ color: item.color || accent, fontSize: "16px" }} />
                <span style={{ color: subText, fontSize: "12px" }}>{item.label}</span>
              </div>
            ))}
          </div>

          {/* স্কিলস এবং এক্সপিরিয়েন্স */}
          <div style={{
            display: "grid",
            gridTemplateColumns: "1fr 2fr",
            gap: "30px",
            marginBottom: "40px",
          }}>
            {/* বাম কলাম - স্কিলস */}
            <div style={{
              background: cardBg,
              padding: "24px",
              borderRadius: "20px",
              boxShadow: "0 5px 20px rgba(0,0,0,0.05)",
              border: "1px solid rgba(0,0,0,0.05)",
            }}>
              <h3 style={{ color: accent, marginBottom: "20px", fontSize: "18px", borderBottom: `2px solid ${accent}`, paddingBottom: "8px" }}>
                Skills
              </h3>
              <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                {skills.map((skill, idx) => (
                  <div key={idx}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px" }}>
                      <skill.icon style={{ color: skill.color, fontSize: "14px" }} />
                      <span style={{ fontSize: "13px", fontWeight: "500" }}>{skill.name}</span>
                    </div>
                    <div style={{
                      width: "100%",
                      height: "4px",
                      background: "#e2e8f0",
                      borderRadius: "2px",
                      overflow: "hidden",
                    }}>
                      <div style={{
                        width: `${90 - idx * 5}%`,
                        height: "100%",
                        background: `linear-gradient(90deg, ${accent}, ${skill.color})`,
                        borderRadius: "2px",
                      }} />
                    </div>
                  </div>
                ))}
              </div>

              <div style={{
                marginTop: "25px",
                padding: "15px",
                background: `linear-gradient(135deg, ${accent}20, ${accent}05)`,
                borderRadius: "12px",
                border: `1px dashed ${accent}`,
              }}>
                <h4 style={{ color: accent, marginBottom: "10px", fontSize: "14px", display: "flex", alignItems: "center", gap: "5px" }}>
                  <FaBolt /> Availability Status
                </h4>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
                  <div>
                    <p style={{ fontSize: "11px", color: subText }}>Available From</p>
                    <p style={{ fontSize: "13px", fontWeight: "bold", color: text }}>{companyInfo.hireInfo.available}</p>
                  </div>
                  <div>
                    <p style={{ fontSize: "11px", color: subText }}>Hourly Rate</p>
                    <p style={{ fontSize: "13px", fontWeight: "bold", color: text }}>{companyInfo.hireInfo.rate}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* ডান কলাম - এক্সপিরিয়েন্স */}
            <div style={{
              background: cardBg,
              padding: "24px",
              borderRadius: "20px",
              boxShadow: "0 5px 20px rgba(0,0,0,0.05)",
              border: "1px solid rgba(0,0,0,0.05)",
            }}>
              <h3 style={{ color: accent, marginBottom: "20px", fontSize: "18px", borderBottom: `2px solid ${accent}`, paddingBottom: "8px" }}>
                Work Experience
              </h3>
              
              {experiences.map((exp, idx) => (
                <div key={idx} style={{ marginBottom: idx === 0 ? "25px" : "0" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                    <h4 style={{ fontSize: "16px" }}>{exp.title}</h4>
                    <span style={{ padding: "2px 10px", background: accent, color: "#fff", borderRadius: "15px", fontSize: "11px" }}>
                      {exp.period}
                    </span>
                  </div>
                  <p style={{ color: accent, fontSize: "13px", marginBottom: "8px" }}>{exp.company}</p>
                  <p style={{ color: subText, fontSize: "13px", lineHeight: "1.5", marginBottom: "12px" }}>
                    {exp.description}
                  </p>
                  <ul style={{ marginLeft: "18px", color: subText, fontSize: "12px" }}>
                    {exp.achievements.map((achievement, i) => (
                      <li key={i} style={{ marginBottom: "4px" }}>{achievement}</li>
                    ))}
                  </ul>
                </div>
              ))}

              <h3 style={{ color: accent, margin: "25px 0 15px", fontSize: "18px", borderBottom: `2px solid ${accent}`, paddingBottom: "8px" }}>
                Education
              </h3>
              <div>
                <h4 style={{ fontSize: "15px", marginBottom: "3px" }}>{education.degree}</h4>
                <p style={{ color: accent, fontSize: "12px", marginBottom: "3px" }}>{education.institution}</p>
                <p style={{ color: subText, fontSize: "11px", marginBottom: "3px" }}>{education.period}</p>
                <p style={{ color: subText, fontSize: "11px", marginBottom: "8px" }}>CGPA: {education.cgpa}</p>
              </div>
            </div>
          </div>

          {/* PDF DOWNLOAD সেকশন */}
          <div style={{
            marginTop: "20px",
            padding: "30px",
            background: `linear-gradient(135deg, ${accent}10, ${accent}05)`,
            borderRadius: "20px",
            border: `2px dashed ${accent}`,
            textAlign: "center",
          }}>
            <h3 style={{
              color: accent,
              fontSize: "24px",
              marginBottom: "15px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}>
              <FaFilePdf />
              Download CV as PDF
            </h3>
            
            <p style={{
              color: subText,
              fontSize: "16px",
              marginBottom: "25px",
              maxWidth: "600px",
              margin: "0 auto 25px",
            }}>
              Get a professionally formatted PDF version of this CV. Perfect for interviews, applications, or offline viewing.
            </p>

            <div style={{
              display: "flex",
              gap: "20px",
              justifyContent: "center",
              flexWrap: "wrap",
            }}>
              {/* PDF Download বাটন */}
              <button
                onClick={handleDownloadPDF}
                disabled={isGeneratingPDF}
                style={{
                  padding: "15px 40px",
                  borderRadius: "50px",
                  border: "none",
                  background: "linear-gradient(135deg, #FF4444, #FF6B6B)",
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: "18px",
                  cursor: isGeneratingPDF ? "wait" : "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  boxShadow: "0 10px 25px rgba(255,68,68,0.3)",
                  transition: "all 0.3s ease",
                  opacity: isGeneratingPDF ? 0.7 : 1,
                }}
                onMouseEnter={(e) => {
                  if (!isGeneratingPDF) {
                    e.currentTarget.style.transform = "scale(1.05)";
                    e.currentTarget.style.boxShadow = "0 15px 30px rgba(255,68,68,0.4)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isGeneratingPDF) {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow = "0 10px 25px rgba(255,68,68,0.3)";
                  }
                }}
              >
                {isGeneratingPDF ? (
                  <>
                    <FaSpinner style={{ animation: "spin 1s linear infinite" }} />
                    Generating PDF...
                  </>
                ) : (
                  <>
                    <FaDownload size={20} />
                    Download PDF
                  </>
                )}
              </button>

              {/* Print বাটন */}
              <button
                onClick={handlePrint}
                style={{
                  padding: "15px 40px",
                  borderRadius: "50px",
                  border: `2px solid ${accent}`,
                  background: "transparent",
                  color: accent,
                  fontWeight: "bold",
                  fontSize: "18px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = accent;
                  e.currentTarget.style.color = "#fff";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "transparent";
                  e.currentTarget.style.color = accent;
                }}
              >
                <FaPrint size={20} />
                Print CV
              </button>
            </div>
          </div>

          {/* নিচের HIRE NOW ব্যানার */}
          <div style={{
            marginTop: "40px",
            textAlign: "center",
          }}>
            <button
              onClick={handleHireClick}
              style={{
                padding: "18px 50px",
                borderRadius: "60px",
                border: "none",
                background: "linear-gradient(135deg, #FF4444, #FF6B6B, #FF8A8A)",
                color: "#fff",
                fontWeight: "bold",
                fontSize: "24px",
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: "15px",
                boxShadow: "0 10px 30px rgba(255,68,68,0.4)",
                transition: "all 0.3s ease",
                position: "relative",
                overflow: "hidden",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.1)";
                e.currentTarget.style.boxShadow = "0 15px 40px rgba(255,68,68,0.5)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "0 10px 30px rgba(255,68,68,0.4)";
              }}
            >
              <FaRocket style={{ fontSize: "28px", animation: "rocket 2s ease-in-out infinite" }} />
              HIRE ME NOW - LET'S WORK TOGETHER!
              <FaHandshake style={{ fontSize: "28px" }} />
            </button>
            
            <p style={{
              marginTop: "15px",
              color: subText,
              fontSize: "14px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}>
              <FaStar style={{ color: "#FFD700" }} />
              <span>100% Satisfaction Guaranteed | 24/7 Support | Fast Response</span>
              <FaStar style={{ color: "#FFD700" }} />
            </p>
          </div>
        </div>

        {/* রেসপন্সিভ স্টাইল */}
        <style>
          {`
            @keyframes spin {
              to { transform: rotate(360deg); }
            }
            @media print {
              body {
                margin: 0;
                padding: 0;
              }
              .no-print {
                display: none !important;
              }
              button {
                display: none !important;
              }
            }
            @media (max-width: 768px) {
              div[style*="grid-template-columns: 1fr 2fr"] {
                grid-template-columns: 1fr !important;
              }
              div[style*="padding: 100px 24px 100px"] {
                padding: 80px 16px 60px !important;
              }
              h1 {
                font-size: 24px !important;
              }
              div[style*="position: absolute"][style*="bottom: -25px"] {
                width: 120px !important;
                font-size: 7px !important;
              }
            }
          `}
        </style>
      </div>
    </>
  );
};

export default CV;